<!-- @format -->

<ng-container *ngIf="features.length">
	<div
		class="hmf-mb-xs"
		[ngClass]="{
			'hmf-body-m hmf-display-flex': filterByUsedFor,
			'review-feature hmf-body-s': !filterByUsedFor,
			'hmf-body-m-m': !filterByUsedFor && !smallFontFamily,
			'hmf-body-m-s': !filterByUsedFor && smallFontFamily
		}">
		<div
			*ngIf="filterByUsedFor"
			class="hmf-py-xxxs">
			Used for:
		</div>
		<div
			[ngClass]="{
				'review-feature-used-for hmf-ml-xxs hmf-px-xs hmf-py-xxxs hmf-body-s hmf-body-m-m':
					filterByUsedFor
			}">
			{{ features | splitContentPipe }}
		</div>
	</div>
</ng-container>
